import { RxHR } from '@akanass/rx-http-request';

import { empty } from 'rxjs';
import { expand, reduce, map } from 'rxjs/operators';

import { PARAM_TYPE_PLACE } from './constants';
// 'https://apex.oracle.com/pls/apex/beyondhorizon/tt/v2/events/last_event'
const basicUrl = 'https://apex.oracle.com/pls/apex/beyondhorizon/tt/';
const eventsEP = 'events';
const paramsRP = 'event_parameters';
const zoomParam = 'q_zoom_level';
const topLatParam = 'q_ul_lat';
const leftLngParam = 'q_ul_long';
const bottomLatParam = 'q_lr_lat';
const rightLngParam = 'q_lr_long';
const source = 'q_source';

//https://apex.oracle.com/pls/apex/beyondhorizon/tt/events
const getFetchLastLocationUrl = () => `${basicUrl}v2/${eventsEP}/last_event`;
const getFetchAllLocationsUrl = () => basicUrl + eventsEP;
//const getFetchAllParamsUrl =  () => basicUrl + paramsRP;
const getFetchLocationParamsUrl = locationId =>
  basicUrl + paramsRP + locationId;
const getFetchAllPhotosUrl = () => basicUrl + paramsRP + '?'; //q_param_type=" + PARAM_TYPE_PHOTO;
const getFetchAllImportantPlacesUrl = () =>
  `${basicUrl}${paramsRP}?q_param_type=${PARAM_TYPE_PLACE}`;
//const getFetchWeatherForLocationUrl = () => basicUrl + paramsRP + "?type=weather";

export const fetchGpsJson = dispatch => {
  getData(`${window.location.origin}/gps.json`).subscribe(data =>
    dispatch({ type: 'FETCH_GPS_JSON', data })
  );
};

export const fetchAllLocations = (dispatch, fromDate) => {
  //ADD from date!
  let url = getFetchAllLocationsUrl() + '?';
  if (fromDate) {
    url = url + 'q_gen_ts=' + fromDate;
  }
  pagingFetch(url).subscribe(data =>
    dispatch({ type: 'FETCH_LOCATIONS', data })
  );
};

export const fetchLocationsByBounds = (dispatch, zoom, bounds, user) => {
  //ADD from date!
  let url = getFetchAllLocationsUrl() + '?';
  if (zoom) {
    url = `${url}${zoomParam}=${zoom}&`;
  }
  if (bounds) {
    const topLat = bounds._northEast.lat;
    const leftLng = bounds._southWest.lng;
    const bottomLat = bounds._southWest.lat;
    const rightLng = bounds._northEast.lng;
    url = `${url}${topLatParam}=${topLat}&`;
    url = `${url}${bottomLatParam}=${bottomLat}&`;
    url = `${url}${leftLngParam}=${leftLng}&`;
    url = `${url}${rightLngParam}=${rightLng}&`;
    url = `${url}${source}=${user}`;
    // url = `${url}${source}=Aleksandra`;
    // url = `${url}${source}=Tomasz`;
    // url = `${url}${source}=T01`;
    // url = `${url}${source}=Dareczek`;
  }
  pagingFetch(url).subscribe(data =>
    dispatch({ type: 'FETCH_LOCATIONS', data })
  );
};

export const fetchAllPhotos = (dispatch, fromDate) => {
  //ADD from date!
  let url = getFetchAllPhotosUrl();
  if (fromDate) {
    url = url + '&q_gen_ts=' + fromDate;
  }
  pagingFetch(url).subscribe(data => dispatch({ type: 'FETCH_PHOTOS', data }));
};

export const fetchAllImportantPlaces = (dispatch, fromDate) => {
  //ADD from date!
  let url = getFetchAllImportantPlacesUrl();
  if (fromDate) {
    url = url + '&q_gen_ts=' + fromDate;
  }
  pagingFetch(url).subscribe(data =>
    dispatch({ type: 'FETCH_IMPORTANT_PLACES', data })
  );
};

export const fetchLocationParams = (dispatch, locationId) => {
  pagingFetch(getFetchLocationParamsUrl(locationId)).subscribe(data =>
    dispatch({ type: 'FETCH_IMPORTANT_PLACES', data })
  );
};

export const fetchLastLocation = dispatch =>
  getData(getFetchLastLocationUrl()).subscribe(data =>
    dispatch({ type: 'FETCH_LAST_LOCATION', data })
  );

const getData = url =>
  RxHR.get(url, { json: true, headers: getHeaders() }).pipe(
    map(response => response.body)
  );

const pagingFetch = url => {
  return getData(url).pipe(
    expand(body => (body.next ? getData(body.next.$ref) : empty())),
    reduce(
      (acc, data) => {
        acc.items = acc.items.concat(data['items']);
        return acc;
      },
      { items: [] }
    )
  );
};

const getHeaders = () => {
  return {
    Authorization: 'Basic QkVZT05EVEhFSE9SSVpPTl9BUFA6OFBOYk5aaGQjI1FUYlg='
  };
};
